import { createSelector, OutputSelector } from 'reselect'
import { IFMCSAInfo, SAFETY_RATING, ICarrier, ICarrierLocation } from 'types/carrier'
import { IStore } from 'apps/booking/utils/reducers'

export const selectCarrier = (state: IStore): ICarrier | undefined => state.carrier.data
export const selectCarrierLocation = (state: IStore): ICarrierLocation | undefined =>
  selectCarrier(state)?.location
export const selectFmcsa = (state: IStore) => state.fmcsa.fmcsaInfo
export const selectCompliance = (state: IStore) => state.options.compliance

type SelectCarrierProfileInfo = Partial<ICarrier> &
  Partial<ICarrierLocation> & {
    fmcsaRating?: SAFETY_RATING
  }

interface SelectCarrierProfileInfoSelector
  extends OutputSelector<
    IStore,
    SelectCarrierProfileInfo,
    (res1?: ICarrier, res2?: ICarrierLocation, res3?: IFMCSAInfo) => SelectCarrierProfileInfo
  > {}

export const selectCarrierProfileInfo: SelectCarrierProfileInfoSelector = createSelector(
  [selectCarrier, selectCarrierLocation, selectFmcsa],
  (carrier, location, fmcsa) => ({
    id: carrier?.id,
    state: carrier?.state,
    legalName: carrier?.legalName,
    mcNumber: carrier?.mcNumber,
    dotNumber: carrier?.dotNumber,
    isTrusted: carrier?.isTrusted,
    fmcsaRating: fmcsa?.rating,
    contactPhone: location?.contactPhone,
    contactPhoneExt: location?.contactPhoneExt,
    isEldApproved: carrier?.isEldApproved,
  })
)
